import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Videos } from '../../components/Videos';

let videosContainerRoot = null;
let rootCreated = false;

export const displayMediaCenterVideoIcon = (media: any): void => {
    const videosContainer = document.querySelector('.videos-wrapper');
    const hideClass = 'is-hidden';

    if (videosContainer) {
        const filterMediaByType = (mediaSets: any, type: string): any[] => mediaSets
            .filter(mediaSet => mediaSet.name === type)
            .reduce((result, mediaSet) => {
                result.push(...mediaSet.images);
                return result;
            }, []);

        const videos = filterMediaByType(media, 'Video');
        const vid = filterMediaByType(media, 'VID');
        const vdc = filterMediaByType(media, 'VDC');
        const pimsVideos = videos.concat(vid, vdc);

        if (!rootCreated) {
            videosContainerRoot = createRoot(videosContainer);
        }

        rootCreated = true;

        videosContainerRoot.render(<Videos videos={pimsVideos}/>);

        const videosIconContainer = document.querySelector('[data-video-dialog-trigger="mediacenter-videos-dialog"]');
        if (videosIconContainer) {
            if (videos.length || pimsVideos.length) {
                videosIconContainer.classList.remove(hideClass);
            } else {
                videosIconContainer.classList.add(hideClass);
            }
        }
    }
}
